<!-- 平台-店铺 级联选择器 -->
<template>
  <el-dialog :title="title" :visible.sync="visible" :closeOnClickModal="false" class="import-class" @close="handleClose">
    <div class="download-template" style="margin-bottom:10px">
      <p style="margin-bottom:10px">1、下载导入模版</p>
      <el-button size="medium" @click="$emit('download')">下载模板</el-button>
    </div>
    <div class="import-template">
      <p style="margin-bottom:10px">2、下载模板并完善信息后，到此处上传</p>
      <div class="import-region" v-loading="loading">
        <el-upload
          class="upload-demo"
          drag
          action="#"
          :multiple="false"
          :before-upload="beforeUpload"
        >
          <template v-if="!fileData">
            <i class="el-icon-upload"></i>
            <p class="upload-text">点击或将文件拖拽到这里上传</p>
            <p class="upload-hint">支持扩展名：xls、xlsx...</p>
          </template>
          <div v-else class="f-c-c fd-c" style="width:100%;height:100%">
            <el-button type="text" style="width:80%;margin-bottom:10px;white-space:normal;" @click.stop="lookFile(fileData)">{{ fileData }}</el-button>
            <div>重新上传</div>
          </div>
        </el-upload>
      </div>
    </div>
    <div slot="footer" class="dialog-footer">
      <el-button @click="visible = false">取 消</el-button>
      <el-button :loading="confirmLoading" type="primary" @click="importExcel">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import API from '@/api'
// import _ from 'lodash'
export default {
  name: 'ImportExcel',
  props: {
    title: {
      type: String,
      default: '导入'
    },
    confirmLoading: {
      type: Boolean,
      default: false
    },
  },
  data() {
    return {
      visible: false,
      fileData: null,
      loading: false
    }
  },
  created() {
  },
  computed: {
  },
  methods: {
    show() {
      this.visible = true
    },
    close() {
      this.visible = false
      this.handleClose()
    },
    // 上传
    beforeUpload(file) {
      this.loading = true
      API.signValue({ directory: 'import/temple/' }).then(({ data }) => {
        let formData = new FormData()
        formData.append('directory', 'import/temple/')
        formData.append('signValue', data)
        formData.append('file', file)
        API.uploadExcelFile(formData).then((result) => {
          if (result.code !== 10000) {
            return this.$message.error(result.message)
          }
          this.$set(this.$data, 'fileData', result.data)
          this.loading = false
        })
      })
      return false
    },
    handleClose() {
      this.fileData = null
    },
    lookFile(data) {
      window.open(data)
    },
    importExcel() {
      if (!this.fileData) {
        return this.$message.warning('请上传文件')
      }
      this.$emit('import', this.fileData)
    },
  }
}
</script>

<style lang="scss" scoped>
.import-class{
  /deep/ .el-dialog__body{
    padding-top: 0;
    padding-bottom: 0;
  }
}

.download-template,
.import-template {
  padding: 14px 21px;
  background-color: #f2f5f9 !important;
}

.import-template {
  height: 321px;
  padding: 14px 26px;
  .import-region {
    width: 384px;
    height: 192px;
    margin: 34px auto;
    position: relative;
    .upload-text {
      color: #15223c;
      font-size: 16px;
    }
    .upload-hint {
      color: #afbbca;
      font-size: 14px;
    }

    .upload-have{
      position: absolute;
      top: 0;
      left: 0;
    }
  }
}

</style>
